import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment';
import { Moment } from 'moment';
import { ApiService } from 'src/app/services/api.service';
import { JwtService } from 'src/app/services/jwt.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackComponent } from '../synopsis/feedback/feedback.component';

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_FORMATS,
    },
  ],
})
export class ReportsComponent implements OnInit {
  buttonClicked: boolean = false;
  reports = {
    client: '',
    reportType: '',
    interval: '',
    year: null,
    comments: '',
  };
  clients = JSON.parse(sessionStorage.getItem('clients'));
  reportTypes = [
    { id: 'monthly', dname: 'Monthly' },
    { id: 'quaterly', dname: 'Quaterly' },
    // { id: 'yearly', dname: 'Yearly' },
  ];
  intervals: any;
  maxDate = new Date();
  title: string;

  constructor(
    private snackbar: MatSnackBar,
    private jwt: JwtService,
    private api: ApiService,
    private mixpanel: MixpanelService,
    private location: Location,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    let page = window.location.pathname.split('/').pop();
    this.setTitle(page);
    this.location.onUrlChange((url: string, state: any) => {
      let page = url.split('/').pop();
      this.setTitle(page);
    });
    this.mixpanel.track('page_view', {
      page: 'Reports',
      category: 'Dashboard',
      button: '-',
    });
    this.jwt.check();
    this.reports.reportType = 'monthly';
    this.reports.year = this.date.value.year();
    this.onReportType();
  }

  setTitle(page: string) {
    if (page == 'leaderboard') {
      this.title = 'Leaderboard';
    } else if (page == 'leaderboardmaritime') {
      this.title = 'Maritime Leaderboard';
    }
  }

  getRes() {
    this.buttonClicked = true;
    this.mixpanel.track('button_click', {
      page: 'Reports',
      category: 'Dashboard',
      button: 'Download',
    });
    this.api.reports(this.reports).subscribe(
      (data: any) => {
        this.buttonClicked = false;
        if (data.status) {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'success',
          });
          window.open(data.data.link);
          this.dialog.open(FeedbackComponent, {
            disableClose: true,
            data: data.data.reportid,
          });
        } else {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'failure',
          });
        }
      },
      (error) => {
        this.buttonClicked = false;
      }
    );
  }

  onReportType() {
    let curDate = new Date().getMonth().toString();
    let month = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    let quaterly = [
      'firstQuater',
      'firstQuater',
      'firstQuater',
      'secondQuater',
      'secondQuater',
      'secondQuater',
      'thirdQuater',
      'thirdQuater',
      'thirdQuater',
      'fourthQuater',
      'fourthQuater',
      'fourthQuater',
    ];
    this.intervals =
      this.reports.reportType == 'monthly'
        ? [
            { id: 'January', dname: 'January' },
            { id: 'February', dname: 'February' },
            { id: 'March', dname: 'March' },
            { id: 'April', dname: 'April' },
            { id: 'May', dname: 'May' },
            { id: 'June', dname: 'June' },
            { id: 'July', dname: 'July' },
            { id: 'August', dname: 'August' },
            { id: 'September', dname: 'September' },
            { id: 'October', dname: 'October' },
            { id: 'November', dname: 'November' },
            { id: 'December', dname: 'December' },
          ]
        : this.reports.reportType == 'quaterly'
        ? [
            { id: 'firstQuater', dname: 'First' },
            { id: 'secondQuater', dname: 'Second' },
            { id: 'thirdQuater', dname: 'Third' },
            { id: 'fourthQuater', dname: 'Fourth' },
          ]
        : [];
    this.reports.interval =
      this.reports.reportType == 'monthly'
        ? month[curDate]
        : this.reports.reportType == 'quaterly'
        ? quaterly[curDate]
        : null;
  }

  date = new FormControl(moment());

  setYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value!;
    ctrlValue.year(normalizedMonthAndYear.year());
    this.date.setValue(ctrlValue);
    this.reports.year = ctrlValue.year().toString();
    datepicker.close();
  }
}
